import { CommunicationDetailsForm, ConfirmationForm, PersonalDetailsForm } from "../types/FormTypes";

import { GlobalUtils } from "./globalUtils";

export enum Genders {
  MALE = "MALE",
  FEMALE = "FEMALE"
}

export enum MaritalStatus {
  MARRIED = "MARRIED",
  UNMARRIED = "UNMARRIED"
}

export const IndianStates: string[] = [
  "Andaman and Nicobar Islands",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Ladakh",
  "Lakshadweep",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Puducherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];

export const personalDetailsInitialValues = (): PersonalDetailsForm => {
  return {
    fullName: "",
    fathersName: "",
    mothersName: "",
    gender: "",
    maritalStatus: "",
    dateOfBirth: "",
    aadhaarCardNumber: "",
    joiningInterest: []
  }
}

export const communicationDetailsInitialValues = (): CommunicationDetailsForm => {
  const userInfo = GlobalUtils.getUserLoginInfo();
  return {
    emailId: userInfo?.emailId || "",
    mobileNumber: userInfo?.mobileNo ? Number(userInfo?.mobileNo) : undefined,
    alternateEmailId: "",
    streetAddress: "",
    city: "",
    district: "",
    postOffice: "",
    state: "",
    isPermanentAddressEnabled: true
  }
}

export const confirmationDetailsInitialValues = (): ConfirmationForm => {
  return {
    qualification: "",
    occupation: "",
    businessDetails: "",
    isPolicyConfirmed: false
  }
}

export const isValidDOB = (dob: string): boolean => {
  if (!dob) return false;
  // Expect dob in YYYY-MM-DD
  const min = "1900-01-01";
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');
  const max = `${yyyy}-${mm}-${dd}`; // allow today, UI input already restricts to yesterday
  return dob >= min && dob <= max;
}

export const handlePersonalDetailsValidate = (values: PersonalDetailsForm): boolean => {
  const requiredPresent = !!(values.dateOfBirth && values.fathersName && values.fullName && values.gender &&
    values.maritalStatus && values.mothersName);
  const dobValid = isValidDOB(values.dateOfBirth);
  // Return true when invalid (same contract as before)
  return !(requiredPresent && dobValid);
}

export const handleCommunicationDetailsValidate = (values: CommunicationDetailsForm): boolean => {
  let result = !(values.streetAddress && values.city && values.state && values?.pinCode && values.mobileNumber && values.emailId && values.district)

  if (!result && !values.isPermanentAddressEnabled) {
    result = !(values.permanentStreetAddress && values.permanentCity && values.permanentstate && values.permanentPinCode)
  }

  return result;
}

export const handleConfirmationDetailsValidate = (values: ConfirmationForm): boolean => {
  return !(values.qualification && values.occupation)
}

export const isEmailValid = (email: string): boolean => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

export const isValidMobileNumber = (phoneNumber: string): boolean => {
  const mobileNumberPattern = /^\d{10}$/;
  return mobileNumberPattern.test(phoneNumber.replace(/\D/g, ''));
}

const getPersonalDetailsValues = (personalDetailsValues: PersonalDetailsForm): any => {
  return {
    firstName: personalDetailsValues.fullName,
    lastName: personalDetailsValues.fullName,
    fatherName: personalDetailsValues.fathersName,
    motherName: personalDetailsValues.mothersName,
    gender: personalDetailsValues.gender,
    maritalStatus: personalDetailsValues.maritalStatus,
    aadhaarCardNumber: personalDetailsValues.aadhaarCardNumber,
    dob: personalDetailsValues.dateOfBirth,
    joiningInterest: personalDetailsValues.joiningInterest.map((i) => i.value)
  }
}

const getCommunicationDetailsValues = (values: CommunicationDetailsForm): any => {
  const currentAddress = {
    addressLine1: values.streetAddress,
    addressLine2: "",
    villageCity: values.city,
    district: values.district,
    state: values.state,
    pincode: values.pinCode?.toString(),
    postOffice: values.postOffice
  };

  const permanentAddress = values.isPermanentAddressEnabled
    ? currentAddress
    : {
        addressLine1: values.permanentStreetAddress,
        addressLine2: "",
        villageCity: values.permanentCity,
        district: values.permanentdistrict,
        state: values.permanentstate,
        pincode: values.permanentPinCode?.toString(),
        postOffice: values.permanentpostOffice
      };

  return {
    mobileNumber: values.mobileNumber?.toString(),
    altMobileNumber: values.alternateMobileNumber?.toString(),
    altEmailId: values.alternateEmailId,
    addressLine1: currentAddress.addressLine1,
    state: currentAddress.state,
    pincode: currentAddress.pincode,
    currentAddress,
    permanentAddress
  };
};


export const generatePayloadForSave = (currentStep: number, personalDetailsValues: PersonalDetailsForm,
  communicationDetailsValues: CommunicationDetailsForm, confirmationValues: ConfirmationForm): any => {
  let formValuesToSave: any = null;
  if (currentStep === 0) {
    formValuesToSave = { ...getPersonalDetailsValues(personalDetailsValues) };
  }
  else if (currentStep === 1) {
    formValuesToSave = {
      ...getPersonalDetailsValues(personalDetailsValues),
      ...getCommunicationDetailsValues(communicationDetailsValues)
    }
  }
  else {
    formValuesToSave = {
      ...getPersonalDetailsValues(personalDetailsValues),
      ...getCommunicationDetailsValues(communicationDetailsValues),
      businessDetails: confirmationValues.businessDetails,
      occupation: confirmationValues.occupation,
      educationalQualification: confirmationValues.qualification
    }
  }
  return formValuesToSave;
}